export const WRAP = 'WRAP';
export const BOX = 'BOX';
export const SUMMARY = 'SUMMARY';
export const VIDEO = 'VIDEO';
